import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import SnackContent from "./snackContent";

interface Props {
  variant: "success" | "warning" | "error" | "info";
  message: string;
  open: boolean;
  close: () => void;
}

class SnackMessage extends React.Component<Props> {
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  // Snackbar do MUI v4 nao dispara onClose no Escape
  handleKeyDown = (event: KeyboardEvent) => {
    if (this.props.open && (event.key === "Escape" || event.key === "Esc")) {
      this.props.close();
    }
  };

  render() {
    const { variant, message, open, close } = this.props;

    return (
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={open}
          onClose={close}
          style={{ zIndex: 8000000 }}
        >
          <SnackContent onClose={close} variant={variant} message={message} />
        </Snackbar>
      </div>
    );
  }
}

export default SnackMessage;
